import { createActions, handleActions } from 'redux-actions';

const initState = {
  summaryData: [],
  detailData: {},
  fetching: false,
  error: null,
};

export const creators = createActions({
  PRJFINANCIALPERF_SUMMARY_REQUEST: (selectedYears, dimDateKeys) => ({
    selectedYears,
    dimDateKeys,
  }),
  PRJFINANCIALPERF_DETAIL_REQUEST: (dimDateKeys, defaultDimDate) => ({
    dimDateKeys,
    defaultDimDate,
  }),
  PRJFINANCIALPERF_SUCCESS: (payload) => payload,
  PRJFINANCIALPERF_FAILURE: (payload) => payload,
});

const summaryReducer = (state, { payload }) => {
  return {
    ...state,
    fetching: true,
    error: null,
  };
};

const detailReducer = (state, { payload }) => {
  return {
    ...state,
    fetching: true,
    error: null,
  };
};

const successReducer = (state, { payload }) => {
  const nextState = Object.assign({}, state, payload);
  nextState.fetching = false;
  return nextState;
};

const failureReducer = (state, { payload }) => {
  return { ...state, fetching: false, error: payload };
};

export default handleActions(
  {
    PRJFINANCIALPERF_SUMMARY_REQUEST: summaryReducer,
    PRJFINANCIALPERF_DETAIL_REQUEST: detailReducer,
    PRJFINANCIALPERF_SUCCESS: successReducer,
    PRJFINANCIALPERF_FAILURE: failureReducer,
  },
  initState,
);
